<template>
  <div id="app">
    <!--<pre style="z-index: 9999; float: left;position: fixed;top: 0;left: 0;height: 100%;overflow: auto;">{{ business }}</pre>-->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'app',
  computed: {
    ...mapGetters('business', ['business'])
  },
  created() {
    // this.$store.dispatch('checkAuth')
    this.checkAuth()
  },
  methods: {
    ...mapActions('authorize', ['checkAuth'])
  }
}
</script>

<style lang="scss">
@import '../node_modules/@fortawesome/fontawesome-free-webfonts/css/fontawesome.css';
@import '../node_modules/@fortawesome/fontawesome-free-webfonts/css/fa-solid.css';
@import '../node_modules/@fortawesome/fontawesome-free-webfonts/css/fa-brands.css';
@import '../node_modules/@fortawesome/fontawesome-free-webfonts/css/fa-regular.css';
// Load CSS
@import '/assets/sass/control-panel.scss';

// Transitioning
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.25s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// app.vue?15d5cfda